var chunkMapping = {
	"0": [
		4648
	],
	"3": [
		4056,
		4349
	],
	"79": [
		5079
	],
	"164": [
		5164
	],
	"165": [
		5165
	],
	"168": [
		5168
	],
	"169": [
		5169
	],
	"170": [
		5170
	],
	"171": [
		5171
	],
	"172": [
		5172
	],
	"173": [
		5173
	],
	"174": [
		5174
	],
	"175": [
		5175
	],
	"176": [
		5176
	],
	"177": [
		5177
	],
	"178": [
		5178
	],
	"179": [
		5179
	],
	"180": [
		5180
	],
	"181": [
		5181
	],
	"182": [
		5182
	],
	"183": [
		5183
	],
	"184": [
		5184
	],
	"185": [
		5185
	],
	"186": [
		5186
	],
	"187": [
		5187
	]
};
var idToExternalAndNameMapping = {
	"4056": [
		"default",
		"./nuorder-components",
		3671
	],
	"4349": [
		"default",
		"./helios-components",
		3671
	],
	"4648": [
		"default",
		"./Containers",
		3581
	],
	"5079": [
		"default",
		"./OrderlessInvoices",
		3581
	],
	"5164": [
		"default",
		"./AsyncEventTracker",
		3581
	],
	"5165": [
		"default",
		"./HostWrapper",
		3581
	],
	"5168": [
		"default",
		"./CheckoutV3",
		3581
	],
	"5169": [
		"default",
		"./CheckoutConfirmation",
		3581
	],
	"5170": [
		"default",
		"./ContactCreditCards",
		3581
	],
	"5171": [
		"default",
		"./AuditDialog",
		3581
	],
	"5172": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3581
	],
	"5173": [
		"default",
		"./InvoiceDialog",
		3581
	],
	"5174": [
		"default",
		"./PaymentDueModal",
		3581
	],
	"5175": [
		"default",
		"./PaymentModal",
		3581
	],
	"5176": [
		"default",
		"./PaymentHistory",
		3581
	],
	"5177": [
		"default",
		"./PaymentConfigurations",
		3581
	],
	"5178": [
		"default",
		"./PaymentPreferences",
		3581
	],
	"5179": [
		"default",
		"./ManagePaymentProcessing",
		3581
	],
	"5180": [
		"default",
		"./MobilePaymentsWrapper",
		3581
	],
	"5181": [
		"default",
		"./PayPage",
		3581
	],
	"5182": [
		"default",
		"./Challenge",
		3581
	],
	"5183": [
		"default",
		"./ManagePaymentMethods",
		3581
	],
	"5184": [
		"default",
		"./LightspeedReports",
		3581
	],
	"5185": [
		"default",
		"./ActivateLightspeedPayments",
		3581
	],
	"5186": [
		"default",
		"./MarketingLandingPage",
		3581
	],
	"5187": [
		"default",
		"./ShippingPromotionsListContainer",
		3581
	]
};
var idToRemoteMap = {
	"4056": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3671
		}
	],
	"4349": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3671
		}
	],
	"4648": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5079": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5164": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5165": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5168": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5170": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5172": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5174": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}